import logo from './logo.svg';
import './App.css';
import ResumeBuilder from './Components/ResumeBuilder';

function App() {
  return (
    <div className="App">
      <ResumeBuilder />
    </div>
  );
}

export default App;
